var PES = PES || {};
PES.ModalPopup = function () {

    var showModal = function () {
        var modalTarget = ".open-modal";
        var slideItem = ".slide-container > .slide-item";
        var currentSlide;
        var thumbSelectors = ".thumb__selectors > li";
        var currentThumb;
        var modalWindow = ".modal-window";
        var modalWindowPlusProSlider = ".modal-window.plus-pro-slider";
        var isPlus = ".plus-section";
        var isPro = ".pro-section";
        var plusButton = "plus-button";
        var proButton = "pro-button";
        var selectGalleryVersion = ".version__button--select";
        var carouselContainer = ".modal-window .carousel-template";
        var bodyContainer = 'body';
        var imageIndex;
        var targetWindow;

        var activatePlus = function () {
            $(isPro).removeClass("active");
            $(".pro-button").removeClass("active");
            $(isPlus).addClass("active");
            $(".plus-button").addClass("active");
            $(carouselContainer).removeClass("pro-banner");
        }

        var activatePro = function () {
            $(isPlus).removeClass("active");
            $(".plus-button").removeClass("active");
            $(isPro).addClass("active");
            $(".pro-button").addClass("active");
            $(carouselContainer).addClass("pro-banner");
        }

        $(modalTarget).on("click", function (e) {
            e.preventDefault();
            imageIndex = $(this).children("img").attr("data-index");
            targetWindow = $(this).attr("data-target");

            if ($(this).hasClass("plus-section")) {
                $(modalWindowPlusProSlider).addClass("active");
                activatePlus();
            } else if ($(this).hasClass("pro-section")) {
                $(modalWindowPlusProSlider).addClass("active");
                activatePro();
            } else if ($(modalWindow).hasClass(targetWindow)) {
                $("." + targetWindow).addClass("active");
            } else if (!$(this).hasClass('plus-addin-button')) {
                $(modalWindow).addClass('active');
            }

            if ($(modalWindow).hasClass("active")) {
                $(bodyContainer).addClass("fixed-position");
            }

            currentSlide = $(slideItem)[imageIndex];
            currentThumb = $(thumbSelectors)[imageIndex];

            $(currentSlide).siblings().removeClass("active");
            $(currentSlide).addClass("active");
            $(currentThumb).siblings().children(".slide-select").removeClass("active");
            $(currentThumb).children(".slide-select").addClass("active");
        });

        $(selectGalleryVersion).on("click", function () {
            if ($(this).hasClass(plusButton)) {
                $("." + plusButton).addClass("active");
                $("." + proButton).removeClass("active");
                activatePlus();
            } else if ($(this).hasClass(proButton)) {
                $("." + proButton).addClass("active");
                $("." + plusButton).removeClass("active");
                activatePro();
            }
        });

        var closeModalWindow = function () {
            if (!$(".modal-window.pro-suggestion").hasClass("active")) {
                $(modalWindow).removeClass("active");
                if ($(isPlus).hasClass("active") || $(isPro).hasClass("active")) {
                    $(isPlus).removeClass("active");
                    $(isPro).removeClass("active");
                    $("." + proButton).removeClass("active");
                    $("." + plusButton).removeClass("active");
                }
            }
            $(bodyContainer).removeClass("fixed-position");
        }

        $(modalWindow).on("click", function (e) {
           e.preventDefault();
            var target = e.target;

            if ($(target).hasClass("close-button") || (!$(target).parents(".layout-section-content.carousel-container").length && !$(target).parents(".modal-window.pro-suggestion").length)) {
                closeModalWindow();
            }
        });

        $(document).on("keydown", function (e) {
            if (e.keyCode === 27 && $(modalWindow).hasClass("active")) {
                closeModalWindow();
            }
        });
    }

    var init = function () {
        showModal();
    }

    return {
        init: init
    }
}